<template>
  <div class="row">
    <div class="col-lg-12">
      <el-alert
        :closable="false"
        class="mb-3 col-12"
        title="💡 Info"
        type="success"
      >
        <p>
          <b>SLA</b> setting is where you can set time for your workspace sla configuration
          when using the call and conversation. The configuration that you enabled and set below will
          determine when you workspace is measure sla time.
        </p>
        <br />
        <p>
          - You can enable and set the sla configuration to define sla time.
        </p>
      </el-alert>
      <el-card shadow="never" v-if="isCanChange()">
        <div class="mb-4">
          <span class="font-weight-bold mr-2" slot="label">Status SLA</span>
          <el-switch v-model="form.status" active-color="#128c7f" />
        </div>
        <div v-if="form.status" class="d-flex">
          <div class="mr-4">
            <p class="font-weight-bold mb-2">Ticket</p>
            <el-form ref="slaForm" label-position="top">
              <el-form-item>
                <p class="mb-3">First Time Response :</p>
                <el-input
                  v-model="form.settings.ticket.first_time_response"
                  @input="onChangeSlaInput('ticket', 'first_time_response')"
                  placeholder="Please input"
                  style="width: 300px"
                >
                  <template slot="append">Minutes</template>
                </el-input>
              </el-form-item>

              <el-form-item>
                <p class="mb-3">Resolution Time :</p>
                <el-input
                  v-model="form.settings.ticket.resolution_time"
                  @input="onChangeSlaInput('ticket', 'resolution_time')"
                  placeholder="Please input"
                  style="width: 300px"
                >
                  <template slot="append">Minutes</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>

          <div v-if="Object.keys(channel_call).length > 0">
            <p class="font-weight-bold mb-2">Call</p>
            <el-form label-position="top" class="d-flex flex-column">
              <el-form-item>
                <p class="mb-3">First Time Response :</p>
                <el-input
                  v-model="form.settings.call.first_time_response"
                  @input="onChangeSlaInput('call', 'first_time_response')"
                  placeholder="Please input"
                  style="width: 300px"
                >
                  <template slot="append">Seconds</template>
                </el-input>
              </el-form-item>

              <el-form-item>
                <p class="mb-3">Resolution Time :</p>
                <el-input
                  v-model="form.settings.call.resolution_time"
                  @input="onChangeSlaInput('call', 'resolution_time')"
                  placeholder="Please input"
                  style="width: 300px"
                >
                  <template slot="append">Seconds</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div align="right">
            <el-button
            @click="updateSla"
            :loading="loading.update_sla"
            size="small"
            class="btn-primary"
            align="right"
            >Update</el-button
            >
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { upperFirst, isEmpty } from 'lodash';
import popupErrorMessages from '../../../library/popup-error-messages';
import customFeatures from '../../../api/customFeatures';
import channelsApi from '../../../api/channels';

export default {
  name: 'Sla',
  props: {
    workspace_id: {
      type: String,
    },
  },
  data() {
    return {
      loading: {
        update_sla: false,
      },
      loaderStack: 0,
      loader: null,
      form: {
        status: false,
        settings: {
          ticket: {
            first_time_response: 0,
            resolution_time: 0,
          },
          call: {
            first_time_response: 0,
            resolution_time: 0,
          },
        },
      },
      channel_call: {},
    };
  },
  mounted() {
  },
  methods: {
    // space(str) {
    //   return str.replace(/_/gi, ' ');
    // },
    // ucwords(str) {
    //   const words = this.space(str).split(' ');
    //   for (let i = 0; i < words.length; i++) {
    //     words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    //   }
    //   return words.join(' ');
    // },
    // get_label_ivr(label_key) {
    //   return `IVR ${this.ucwords(label_key)}`;
    // },
    isCanChange() {
      let result = false;
      const { is_pic } = this.$store.state.auth.userProfile;
      if (is_pic === true) {
        result = true;
      }
      return result;
    },
    upperCaseFirst(string) {
      return upperFirst(string);
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async loadData() {
      this.$parent.loading.setting = true;
      const response = await customFeatures.getCustomFeature(this.workspace_id);
      this.hideLoader();
      this.$parent.loading.setting = false;
      await this.loadChannelPhoneCall();
      await popupErrorMessages(response);
      const feature = response.data;
      console.log(feature);
      if (!isEmpty(feature.sla)) {
        this.form = feature.sla;
      }
    },
    async loadChannelPhoneCall() {
      this.$parent.loading.setting = true;
      const response = await channelsApi.getChannelPhoneCall(this.workspace_id);
      this.hideLoader();
      this.$parent.loading.setting = false;
      await popupErrorMessages(response);
      const channel_phone_call = response.data;
      this.channel_call = channel_phone_call;
    },
    async updateSla() {
      this.loading.update_sla = true;
      this.$parent.loading.call = true;
      const validationTicket = !this.form.settings.ticket.first_time_response || !this.form.settings.ticket.resolution_time;
      const validationCall = Object.keys(this.channel_call).length > 0 && (!this.form.settings.call.first_time_response || !this.form.settings.call.resolution_time);
      if (validationTicket || validationCall) {
        this.$message({
          type: 'error',
          message: 'Sla input should required',
        });
        this.$parent.loading.call = false;
        this.loading.update_sla = false;
        return;
      }
      const response = await customFeatures.updateSla(
        this.workspace_id,
        {
          status: this.form.status,
          ticket: this.form.settings.ticket,
          call: this.form.settings.call,
        },
      );
      this.hideLoader();
      this.$parent.loading.call = false;
      this.loading.update_sla = false;
      await popupErrorMessages(response);
      await this.loadData();
      this.$message({
        type: 'success',
        message: this.$t('settings.success.edit'),
      });
    },
    onChangeSlaInput(key, field) {
      const value = this.form.settings[key][field].replace(/\D/g, '');
      this.$set(this.form.settings[key], field, value);
    },
  },
};
</script>
